import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';

import { UsuarioService } from '../services/usuario.service';
import { SessionService } from '../services/session.service';

@Component({
    selector: 'login-cmp',
    templateUrl: './login.component.html',
    providers: [ UsuarioService, SessionService ]
})

export class LoginComponent implements OnInit{

    constructor(
        private activatedRoute: ActivatedRoute,
        private NavRoute: Router,
        private usuarioService: UsuarioService,
        private ss: SessionService
    ) {
    	this.activatedRoute.params.forEach((params: Params) => {
            sessionStorage.setItem('api-token', params['token']);
			this.usuarioService.getByUser(params['usuario'],"").subscribe(
				data => {
					this.ss.setData(data).then(()  => this.NavRoute.navigate(['desktop']));
				}
			);
		});
    }

    ngOnInit(){
		
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/login/login.component.ts